export default "__VITE_ASSET__d23e2830__"